import { createAsyncThunk } from "@reduxjs/toolkit";
import { get, post, put, del } from "../../Services/ApiBase";
import { API_ENDPOINTS } from "../../Services/ApiEndPoints";
import { getApiErrorMessage } from "../../utils/apiErrorMessage";

export const fetchSavedSearches = createAsyncThunk(
  "savedSearches/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await get(API_ENDPOINTS.WORK_ITEMS.SAVED_SEARCH);
      // Envelope: { success: true, data: SavedSearch[] }
      const data = response?.data?.data ?? response?.data;
      return Array.isArray(data) ? data : [];
    } catch (err) {
      return rejectWithValue(getApiErrorMessage(err, "Failed to load saved searches"));
    }
  }
);

export const createSavedSearch = createAsyncThunk(
  "savedSearches/create",
  async ({ name, filters }, { rejectWithValue }) => {
    try {
      const response = await post(API_ENDPOINTS.WORK_ITEMS.SAVED_SEARCH, { name, filters });
      return response?.data?.data ?? response?.data ?? null;
    } catch (err) {
      return rejectWithValue(getApiErrorMessage(err, "Failed to create saved search"));
    }
  }
);

export const updateSavedSearch = createAsyncThunk(
  "savedSearches/update",
  async ({ id, name, filters }, { rejectWithValue }) => {
    try {
      const body = {};
      if (name !== undefined) body.name = name;
      if (filters !== undefined) body.filters = filters;
      const response = await put(API_ENDPOINTS.WORK_ITEMS.SAVED_SEARCH_BY_ID(id), body);
      return response?.data?.data ?? response?.data ?? null;
    } catch (err) {
      return rejectWithValue(getApiErrorMessage(err, "Failed to update saved search"));
    }
  }
);

export const deleteSavedSearch = createAsyncThunk(
  "savedSearches/delete",
  async (id, { rejectWithValue }) => {
    try {
      // DELETE returns 204 No Content — do not parse body
      await del(API_ENDPOINTS.WORK_ITEMS.SAVED_SEARCH_BY_ID(id));
      return id;
    } catch (err) {
      return rejectWithValue(getApiErrorMessage(err, "Failed to delete saved search"));
    }
  }
);
